module.exports = __webpack_public_path__ + "3399489a0decef8b0faa0a01233b7c39.svg";